import { memo, useContext } from "react";
import PropTypes from "prop-types";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import SmartDPMarketingHeroImage from "app/pages/SmartDP/SmartDPMarketingHeroImage/SmartDPMarketingHeroImage";
import SimpleBackgroundProgressiveImg from "app/pages/.shared/SimpleBackgroundProgressiveImg";
import SmartDPHeroCommercialContent from "app/pages/SmartDP/SmartDPHeroCommercial/SmartDPHeroCommercialContent";
import "./SmartDPHeroCommercial.scss";

const IMG_SIZES = {
	medium: { width: 978 },
	small: { width: 768 },
	large: { width: 1847 },
	xlarge: { width: 1847 },
};

const SmartDPHeroCommercial = ({ heroCommercialMerch = {}, useSimpleBackgroundImage = false }) => {
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL;

	const MainDesktop =
		heroCommercialMerch?.displayOptions?.heroCommercial?.mainDesktop ||
		heroCommercialMerch?.mainPhotoLarge?.url;

	const MainMobile =
		heroCommercialMerch?.displayOptions?.heroCommercial?.mainMobile ||
		heroCommercialMerch?.mainPhotoSmall?.url;

	const MainDesktopThumbnail =
		heroCommercialMerch?.displayOptions?.heroCommercial?.mainDesktopThumbnail ||
		heroCommercialMerch?.mainPhotoLarge?.thumbnail;
	const MainMobileThumbnail =
		heroCommercialMerch?.displayOptions?.heroCommercial?.mainMobileThumbnail ||
		heroCommercialMerch?.mainPhotoSmall?.thumbnail;
	const backgroundImageUrl = isMobile ? MainMobile : MainDesktop;

	const backgroundImageThumbnail = isMobile ? MainMobileThumbnail : MainDesktopThumbnail;
	return (
		<>
			<div
				className="smartDP-hero-commercial__image-background"
				data-testid="smartDP-hero-commercial-image-background"
			>
				{useSimpleBackgroundImage ? (
					<div style={{ width: "100%", height: "100%" }}>
						<SimpleBackgroundProgressiveImg
							sizes={IMG_SIZES}
							resolution={resolution}
							src={backgroundImageUrl}
							backgroundPosition="center"
							quality="q_auto:best"
							cloudinaryOptions={[]}
						/>
					</div>
				) : (
					<SmartDPMarketingHeroImage
						imageUrl={backgroundImageUrl}
						imageThumbnail={backgroundImageThumbnail}
						backgroundPosition="center"
						isBackgroundProgressiveImg={true}
						sizes={IMG_SIZES}
					/>
				)}
				<div className="smartDP-hero-commercial__content">
					<SmartDPHeroCommercialContent heroCommercialMerch={heroCommercialMerch} />
				</div>
			</div>
		</>
	);
};
SmartDPHeroCommercial.propTypes = {
	heroCommercialMerch: PropTypes.object,
	useSimpleBackgroundImage: PropTypes.bool,
};
export default memo(SmartDPHeroCommercial);
